import { t } from "@/i18n-js/instance";
import {
  EMAIL_REGEX,
  PASSWORD_REGEX,
} from "@circle-react/components/OnboardingPage/helpers/constants";
import { authenticationAppRoutes } from "@circle-react/components/OnboardingPage/helpers/routes";
import { Form } from "@circle-react-uikit/Form";
import { AcceptTermsLabel } from "./AcceptTermsLabel";
import EmailSuggestion from "./EmailSuggestion";
import { ExistingAccountError } from "./ExistingAccountError";
import type { SignUpFormFieldsProps } from "./types";

const localeScope = "authentication_app.signup";

export const SignUpFormFields = ({
  errors,
  suggestedEmail,
  validateEmail,
  queryParams,
}: SignUpFormFieldsProps) => (
  <>
    {/* Standard flow: name, email, password */}
    <Form.Item
      isFirstChild
      name="user[name]"
      label={t(`${localeScope}.form.name`)}
      hideDescription
      className="no-padding-top no-margin"
      hideBorder
      rules={{
        required: t(`${localeScope}.form.errors.name_required`),
      }}
    >
      <Form.Input autoFocus data-testid="user_name" />
    </Form.Item>
    <Form.Item
      name="user[email]"
      label={t(`${localeScope}.form.email`)}
      hideDescription
      className="no-padding-top no-margin"
      hideBorder
      rules={{
        required: t(`${localeScope}.form.errors.email_required`),
        pattern: {
          value: EMAIL_REGEX,
          message: t(`${localeScope}.form.errors.email_invalid`),
        },
        validate: { emailDeliverable: validateEmail },
      }}
    >
      <Form.Input type="email" data-testid="user_email" />
      {errors?.email && (
        <ExistingAccountError
          loginUrl={`${authenticationAppRoutes.signIn({ params: queryParams })}#email`}
        />
      )}
    </Form.Item>
    {suggestedEmail && <EmailSuggestion suggestedEmail={suggestedEmail} />}
    <Form.Item
      name="user[password]"
      className="no-padding-top no-margin"
      label={t(`${localeScope}.form.password`)}
      hideDescription
      hideBorder
      rules={{
        required: t(`${localeScope}.form.errors.password_required`),
        pattern: {
          value: PASSWORD_REGEX,
          message: t(`${localeScope}.form.errors.password_invalid`),
        },
      }}
    >
      <Form.Input type="password" data-testid="password" />
    </Form.Item>
    <div className="mt-4 flex items-center justify-center">
      <Form.Item
        id="user[terms_of_service]"
        name="user[terms_of_service]"
        hideDescription
        hideBorder
        className="!p-0"
        hideLabel
        rules={{
          required: t(`${localeScope}.form.errors.terms_required`),
        }}
      >
        <Form.Checkbox
          name="user[terms_of_service]"
          label={<AcceptTermsLabel />}
          data-testid="user_terms_of_service"
        />
      </Form.Item>
    </div>
  </>
);
